/**
 * 純文字 / 富文字（HTML）互轉工具。
 *
 * 資料庫裡的欄位（例如 project_bookings.content）同時存在兩種格式：
 * 舊記錄是使用者在 textarea 打的純文字（用 \n 換行），
 * 新記錄是 Quill 編輯器產生的 HTML。顯示與編輯都要能吃這兩種。
 */

const HTML_TAG_PATTERN = /<\/?[a-z][\s\S]*>/i;

/** 判斷字串是否已經是 HTML（而非純文字） */
export function isHtmlContent(value) {
  if (!value || typeof value !== "string") return false;
  return HTML_TAG_PATTERN.test(value);
}

/** 跳脫 HTML 特殊字元，避免純文字被當成標籤解析 */
export function escapeHtml(value) {
  if (value === null || value === undefined) return "";
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/** 把純文字轉成保留換行的 HTML（每行一個 <p>，空行用 <br>） */
export function plainTextToHtml(value) {
  if (!value) return "";
  return String(value)
    .split(/\r\n|\r|\n/)
    .map((line) => (line.trim() === "" ? "<p><br></p>" : `<p>${escapeHtml(line)}</p>`))
    .join("");
}

/** 取出 HTML 的可見文字，用來判斷內容是否真的為空 */
export function htmlToPlainText(value) {
  if (!value) return "";
  if (!isHtmlContent(value)) return String(value);
  const el = document.createElement("div");
  el.innerHTML = value;
  return (el.textContent || el.innerText || "").replace(/ /g, " ");
}

/**
 * 統一輸出成可以用 v-html 呈現的 HTML。
 * 純文字會被跳脫後保留換行，HTML 則原樣輸出。
 */
export function toDisplayHtml(value) {
  if (!value) return "";
  return isHtmlContent(value) ? String(value) : plainTextToHtml(value);
}
